<template>
  <v-form v-model="formValid" ref="myForm">
  <div class="w-100 form-datos d-flex flex-wrap">
        <div class="col-25">
           <v-text-field
            :label="$t('lang.personas.alias') "
            ref='ialias'
            id='ialias'
            class="mx-2"
            v-model='personaParam.mspersonaalias'
            :rules="[rules.aliasDim]"
          ></v-text-field>
        </div>
        <div class="col-25">
          <!-- DNI -->
           <v-text-field
            :label="$t('lang.personas.dni') "
            v-model='personaParam.mspersonadni'
            :rules="[rules.dni]"
            class="mx-2"
            ref='idni'
            id='idni'
          ></v-text-field>
        </div>
      <!-- NOMRE, APELLIDO1, APELLIDO2 -->
        <div class="col-25">
          <!-- NOMBRE -->
          <v-text-field
            :label=" $t('lang.personas.nombre')"
            ref='inombre'
            id='inombre'
            class="mx-2"
            v-model='personaParam.mspersonanombre'
            :rules="[rules.nombreDim, rules.required]"
          ></v-text-field>
        </div>
        <div class="col-25">
          <!-- APELLIDO1 -->
            <v-text-field
            :label=" $t('lang.personas.apellidos')"
             ref='iapellido1'
            id='iapellido1'
             class="mx-2"
            v-model='personaParam.mspersonaapellido1'
            :rules="[rules.apellido1Dim]"
          ></v-text-field>
        </div>
        <v-divider class="w-100 mb-2"></v-divider>
      <div class="col-33">
         <v-select
          ref='ipais'
          v-model='personaParam.mspersonapais'
          :items="paises"
          class="mx-2"
          :label="$t('lang.personas.pais')"
          item-text="mspaisnomesp"
          item-value="mspaisid"
          @change="paisChange"
        ></v-select>
      </div>
      <div class="col-33">
         <v-select
          ref='iprovincia'
          class="mx-2"
          :items="provincias"
          :label="$t('lang.personas.provincia') "
          item-text="msprovincianomesp"
          item-value="msprovinciaid"
           v-model='personaParam.mspersonaprovincia'
          >
          </v-select>
      </div>
      <div class='col-33'>
        
        <!-- POBLACION -->
           <v-text-field
            :label=" $t('lang.personas.poblacion')"
            ref='ipoblacion'
            id='ipoblacion'
            class="mx-2"
            v-model='personaParam.mspersonapoblacion'
            :rules="[rules.poblacionDim]"
          ></v-text-field>
      </div>
      <div class="col-66" >
          <!-- DIRECCION -->
           <v-text-field
            :label=" $t('lang.personas.direccion')  "
            ref='icalle'
            id='icalle'
            class="mx-2"
            v-model='personaParam.mspersonacalle'
            :rules="[rules.direccionDim]"
          ></v-text-field>
        </div>
        <div class="col-33">
          <!-- CP -->
           <v-text-field
            :label=" $t('lang.personas.cp') "
             ref='icp'
            id='icp'
            class="mx-2"
            v-model='personaParam.mspersonacodpostal'
            :rules="[rules.cpDim]"
          ></v-text-field>
        </div>
        <v-divider class="w-100 mb-2"></v-divider>
          <!-- Direccion, CP -->
        
     
      <!-- FIN Direccion, CP -->
         <div class="col-33">
          <!-- FECHA NACIMIENTO -->
           <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="personaParam.mspersonafechanac"
                :label="$t('lang.personas.fechanac') "
                append-icon="event"
                readonly
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                :rules="[rules.fechanac]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="personaParam.mspersonafechanac"
              no-title
              color="primary"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="col-33">
          <!-- MOVIL -->
          <v-text-field
            :label=" $t('lang.personas.movil') "
            ref='imovil'
            id='imovil'
             class="mx-2"
            v-model='personaParam.mspersonatelmovil'
            :rules="[rules.required, rules.movil, rules.movilDim]"
            type='tel'
          ></v-text-field>
        </div>
        <div class="col-33">
          <!-- TELEFONO -->
          <v-text-field
            :label="$t('lang.personas.telefono')"
             ref='itelefono'
            id='itelefono'
            class="mx-2"
            v-model='personaParam.mspersonatel'
            type='tel'
          ></v-text-field>
        </div>
      
      <!-- FIN email, movil, Telefono -->
       
        <div class="col-33 no-flex">
          <!-- EMAIL -->
          <v-text-field
            :label=" $t('lang.personas.email') "
            ref='iemail'
            id='iemail'
            class="mx-2"
            v-model='personaParam.mspersonaemail'
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </div>
         <!-- password -->
          <div class="col-33"  v-if="isSys4Conjunto()">
            <!-- password -->
            <v-text-field
             :label="$t('lang.personas.contrasenha')"
              ref='ipassword'
              id='ipassword'
              class="mx-2"
              v-model='pass'
              type='password'
              >
            </v-text-field>
          </div>
          <div class="col-33" v-if="isSys4Conjunto()">
            <!-- password -->
            <v-text-field
              :label="'Rep. '+ $t('lang.personas.contrasenha')"
              ref='ireppassword'
              id='ireppassword'
              class="mx-2"
              v-model='repPass'
              type='password'
              >
            </v-text-field>
          </div>
    </div>
  </v-form>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService'
import { PaisApiService } from '@/api/PaisApiService'
import { ProvinciaApiService } from '@/api/ProvinciaApiService'
import LoginApiService from '@/api/LoginApiService'
import { Util } from '@/api/Util'

const personaApiService = new PersonaApiService()
const paisApiService = new PaisApiService()
const provinciaApiService = new ProvinciaApiService()
const util = new Util()

export default {
  data () {
    return {
      formValid: false,
      menu2:false,
      user: this.$store.getters.getUserName,
      paises: [],
      provincias: [],
      isMountedDatos: false,
      pass: '',
      repPass: '',
      // Caracteres máximos de los inputs
      maxchar: {
        mspersonaaliasmaxchars: 128,
        mspersonanombremaxchars: 128,
        mspersonaapellido1maxchars: 50,
        // mspersonaapellido2maxchars: 50,
        mspersonacallemaxchars: 128,
        mspersonacodpostalmaxchars: 20,
        mspersonapoblacionmaxchars: 128,
        mspersonatelmaxchars: 25,
        mspersonatelmovilmaxchars: 25,
        mspersonaemailmaxchars: 128
      },
      rules: {
        required: value => !!value || this.$t('lang.error.camposObligatorios'),
        aliasDim: () => this.validAliasDim() || this.$t('lang.error.caracteresMaximos'),
        nombreDim: () => this.validNombreDim() || this.$t('lang.error.caracteresMaximos'),
        apellido1Dim: () => this.validApellido1Dim() || this.$t('lang.error.caracteresMaximos'),
        direccionDim: () => this.validDireccionDim() || this.$t('lang.error.caracteresMaximos'),
        cpDim: () => this.validCpDim() || this.$t('lang.error.caracteresMaximos'),
        poblacionDim: () => this.validPoblacionDim() || this.$t('lang.error.caracteresMaximos'),
        movilDim: () => this.validTelMovilDim() || this.$t('lang.error.caracteresMaximos'),
        dni: () => this.validDniFormat() || this.$t('lang.error.formatoIncorrecto'),
        email: () => this.validEmailFormat() || this.$t('lang.error.formatoIncorrecto'),
        movil: () => this.validTelFormat() || this.$t('lang.error.formatoIncorrecto'),
        fechanac: () => this.validFechaNacFormat() || this.$t('lang.error.formatoIncorrecto'),
        
      },
    }
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number,
    clickGuardarDatosPersona: Number
  },
  mounted () {
    this.init()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        // if (n.mspersonaid !== o.mspersonaid) {
          // this.reset(n)
          this.init()
        // }
      },
      deep: true
    },
    // paises: {
    //   handler (n, o) {
    //     // Seleccionamos el primer input
    //     this.$refs.ialias.focus()
    //   },
    //   deep: true
    // },
    clickGuardarDatosPersona: {
      handler (n, o) {
        this.guardar()
      },
      deep: true
    }
  },
  methods: {
    init () {
      this.getAllPais()
      this.getProvinciasByPais()
      if (this.personaParam.mspersonapais === null || this.personaParam.mspersonapais === '') {
        this.personaParam.mspersonapais = 'ES'
      }
      if (this.personaParam.mspersonaprovincia === null || this.personaParam.mspersonaprovincia === '') {
        this.personaParam.mspersonaprovincia = ''
      }
    },
    reset (persona) {
      this.getProvinciasByPais()
      if (persona.mspersonapais === null || persona.mspersonapais === '') {
        this.personaParam.mspersonapais = 'ES'
      }
      // Seleccionamos el primer input
      this.$refs.ialias.focus()
    },
    paisChange () {
      this.personaParam.mspersonaprovincia = ''
      this.getProvinciasByPais()
    },
    getAllPais () {
      // if (this.personaParam) {
        paisApiService.getAllPais()
          .then(data => {
            // util.mostrarEnConsola('PersonasTabDatosPersonales - getAllPais', data.length, 'OK')
            this.paises = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getAllPais', error, 'ERROR')
          })
      // }
    },
    getProvinciasByPais () {
      if (this.personaParam !== null) {
        provinciaApiService.getProvinciasByPais(this.personaParam.mspersonapais)
          .then(data => {
            // util.mostrarEnConsola('PersonasTabDatosPersonales - getProvinciasByPais', data.length, 'OK')
            this.provincias = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabDatosPersonales - getProvinciasByPais', error, 'ERROR')
          })
      }
    },
    showCorrectAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'info')
    },
    showErrorAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'error')
    },
    guardar () {
      if (this.pass !== '' && this.repPass !== '') {
        this.cambiarPassword()
      } else {
        this.$refs.myForm.validate()
        if (this.formValid) {
          this.personaParam.mspersonausumodif = this.user.substring(0,50)
          personaApiService.updatePersona(this.personaParam)
            .then(data => {
              if (data.status === 200) {
                this.formValid = false
                // util.mostrarEnConsola('PersonasTabDatosPersonales - updatePersona', data.status, 'OK')
                // Guardamos en sesion la persona
                sessionStorage.setItem('personaAux', JSON.stringify(this.personaParam))
                // this.$router.push('/Personal')
                this.showCorrectAlert(this.$t('lang.personas.alerta.correcto'))
              }
            })
            .catch(error => {
              this.showErrorAlert(this.$t('lang.personas.alerta.error'))
              util.mostrarEnConsola('PersonasTabDatosPersonales - updatePersona', error, 'ERROR')
            })
        }
      }
    },
    cambiarPassword () {
      if (this.pass === this.repPass) {
        LoginApiService.cambiarPassAdmin(this.personaParam.mspersonaid, this.repPass)
          .then(() => {
            this.showCorrectAlert('Contraseña actualizada correctamente')
            this.pass = ''
            this.repPass = ''
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 403 || error.response.status === 401) {
              this.showErrorAlert("Contraseña incorrecta") 
            } else {
              this.showErrorAlert("Ha ocurrido un error al cambiar la contraseña")
            }
          })
      } else {
        this.showErrorAlert("Las contraseñas no coinciden")
      }
    },
    validAliasDim: function () {
      if (this.personaParam) {
        if (util.isValidStringField(this.personaParam.mspersonaalias, this.maxchar.mspersonaaliasmaxchars)) {
          return true
        } else {
          return false
        }
      }
    },
    validDniFormat: function () {
      if (this.personaParam) {
        if (!util.isValidDni(this.personaParam.mspersonadni)) {
          return false
        } else {
          return true
        }
      }
    },
    validDniObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonadni)) {
          return false
        } else {
          return true
        }
      }
    },
    validNombreDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonanombre, this.maxchar.mspersonanombremaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validNombreObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonanombre)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido1Dim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaapellido1, this.maxchar.mspersonaapellido1maxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido1Obligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonaapellido1)) {
          return false
        } else {
          return true
        }
      }
    },
    validPassObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.pass) || util.isEmptyField(this.repPass)) {
          return false
        } else {
          return true
        }
      }
    },
    validApellido2Dim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaapellido2, this.maxchar.mspersonaapellido2maxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validDireccionDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonacalle, this.maxchar.mspersonacallemaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validCpDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonacodpostal, this.maxchar.mspersonacodpostalmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validPoblacionDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonapoblacion, this.maxchar.mspersonapoblacionmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validEmailDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonaemail, this.maxchar.mspersonaemailmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validEmailFormat: function () {
      if (this.personaParam) {
        if (!util.isValidEmail(this.personaParam.mspersonaemail)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonatel, this.maxchar.mspersonatelmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelFormat: function () {
      if (this.personaParam) {
        if (!util.isValidTelefono(this.personaParam.mspersonatel, this.maxchar.mspersonatelmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelMovilDim: function () {
      if (this.personaParam) {
        if (!util.isValidStringField(this.personaParam.mspersonatelmovil, this.maxchar.mspersonatelmovilmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validTelMovilFormat: function () {
      if (this.personaParam) {
        if (!util.isValidTelefono(this.personaParam.mspersonatelmovil, this.maxchar.mspersonatelmovilmaxchars)) {
          return false
        } else {
          return true
        }
      }
    },
    validFechaNacFormat: function () {
      if (this.personaParam) {
        if (!util.isValidFecha(this.personaParam.mspersonafechanac)) {
          return false
        } else {
          return true
        }
      }
    },
    validFechaNacObligatorio: function () {
      if (this.personaParam) {
        if (util.isEmptyField(this.personaParam.mspersonafechanac)) {
          return false
        }
      }
    }
  },
}
</script>
